// extracted by mini-css-extract-plugin
export default {"section":"FormSection_section__k-bol","title":"FormSection_title__D22qF","step":"FormSection_step__vcy6Z"};